import { HeaderNavBar } from '@/components/content/Header/parts/NavBar';
import { Box } from '@mui/material';
import { FC, Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { ID } from '@/data/types/Basic';
import { Promotions } from '@/components/content/Header/parts/Promotions';
import { HeaderNavBarMobile } from '@/components/content/Header/parts/HeaderNavBarMobile';
import useMediaQuery from '@mui/material/useMediaQuery';
import { headerContainerSX } from '@/components/content/Header/styles/container';
import { HeaderNavBarContentRecommendation } from '@/components/content/Header/parts/HeaderNavBarContentRecommendation';
import { LoadingBar } from './parts/LoadingBar';

export const useMobileHeaderQuery = () => useMediaQuery(`(max-width:1333px)`);

export const Header: FC<{
	id: ID;
}> = ({ id }) => {
	const isMobile = useMobileHeaderQuery();
	const [visible, setVisible] = useState(true);
	const lastScrollYRef = useRef(0);

	const navBarRecommendation = useMemo(() => <HeaderNavBarContentRecommendation />, []);

	const handleScroll = () => {
		const currentScrollY = window.scrollY;

		if (currentScrollY > lastScrollYRef.current && currentScrollY > 100) {
			setVisible(false);
		} else {
			setVisible(true);
		}

		lastScrollYRef.current = currentScrollY;
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<Fragment>
			<LoadingBar/>
			<Box sx={{ position: 'relative', zIndex: 9001 }}>
				<Promotions id={id} mobile={isMobile} />
			</Box>
			<Box component="header" sx={headerContainerSX(visible)} id="header">
				{isMobile ? (
					<HeaderNavBarMobile id={id} navBarRecommendation={navBarRecommendation} />
				) : (
					<HeaderNavBar navBarRecommendation={navBarRecommendation} />
				)}
				<Box />
			</Box>
		</Fragment>
	);
};
